exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "  #app {\r\n    font-family: 'Space Grotesk', sans-serif;\r\n    -webkit-font-smoothing: antialiased;\r\n    -moz-osx-font-smoothing: grayscale;\r\n    \r\n  }\r\n\r\n  #videoTemplate {\r\n    background-image: url(\"/static-appopensalud/img/background.svg\");\r\n    background-repeat: no-repeat;\r\n    background-attachment: fixed;\r\n    background-position: center;\r\n    width: 100vw;\r\n    height: calc(100vh);\r\n    /* background-color: #E4E4E4; */\r\n  }\r\n\r\n  .b-table-sticky-header > .table.b-table > thead > tr > th {\r\n    top: -1px !important;\r\n  }\r\n\r\n  .custom-select {\r\n    font-size:0.875rem;\r\n  }\r\n\r\n  .b-form-spinbutton {\r\n    font-size:0.875rem;\r\n  }\r\n\r\n  .input-group-text {\r\n    font-size:0.875rem;\r\n  }\r\n\r\n  #smartsupp-widget-container > div {\r\n    z-index: 1000 !important;\r\n  }", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false}!./static-appopensalud/css/general.css
// module id = 1322
// module chunks = 116